const purchaseRoutes = [
  {
    path: '/:prefix(test)?/purchases/pending-receive',
    name: 'PendingReceiveList',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Pendientes por recibir'
    },
    component: () => import('@/modules/purchase/pending-receive/views/PendingReceiveList')
  },
  {
    path: '/:prefix(test)?/purchases',
    name: 'PurchaseList',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Compras'
    },
    component: () => import('@/modules/purchase/views/PurchaseList')
  },
  {
    path: '/:prefix(test)?/purchases/:id',
    name: 'PurchaseRetrieve',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      use: ['fc', 'ax'],
      title: 'Información de documento'
    },
    component: () => import('@/modules/purchase/views/Main')
  },
  {
    path: '/:prefix(test)?/purchases/pending-receive/:id',
    name: 'PendingReceiveRetrieve',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'PurchaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Información de documento pendiente'
    },
    component: () => import('@/modules/purchase/pending-receive/views/Main')
  }
]
export default purchaseRoutes